
import { ShiftTypeModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { Guid } from '@/libs/common/functions/guid';
import { shiftTypesStore } from '@/libs/shift-types/+state/store';
import ShiftTypeDialog from '@/libs/settings/components/ShiftTypeDialog.vue';

@Component({
    components: {
        ShiftTypeDialog,
    },
})
export default class ShiftTypes extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('shiftTypes.code'), value: 'code', align: 'left', sortable: false },
            { text: this.$i18n.t('shiftTypes.name'), value: 'name', align: 'left', sortable: false },
            { text: this.$i18n.t('shiftTypes.fromTime'), value: 'fromTime', align: 'left', sortable: false },
            { text: this.$i18n.t('shiftTypes.toTime'), value: 'toTime', align: 'left', sortable: false },
            { text: this.$i18n.t('shiftTypes.shiftNumber'), value: 'shiftNumber', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: ShiftTypeDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return shiftTypesStore.useGetter(CrudGetter.Pending);
    }

    get shiftTypes(): ShiftTypeModel[] {
        return [...shiftTypesStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...shiftTypesStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        shiftTypesStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<ShiftTypeModel>(
            [
                { field: 'shiftNumber', index: 1, order: 'asc' },
                { field: 'name', index: 2, order: 'asc' },
            ],
            this.getFilters()
        );
    }

    open(item: ShiftTypeModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
